document.addEventListener('click', function(event) {
  const button = event.target.closest('.js-card-option-button');

  if (!button) return;

  const cardWrapper = button.closest('.product-card__wrapper');
  const variantOptionsWrapper = button.closest('.js-card-variant-options');

  if (!cardWrapper || !variantOptionsWrapper) return;

  const variantDataScript = variantOptionsWrapper.querySelector('.js-card-variant-data');

  if (!variantDataScript) return;

  let variants = [];

  try {
    variants = JSON.parse(variantDataScript.textContent);
  } catch (error) {
    return;
  }

  const optionPosition = Number(button.dataset.optionPosition);
  const optionValue = button.dataset.optionValue;

  if (!optionPosition || !optionValue) return;

  const currentVariantId = variantOptionsWrapper.dataset.currentVariantId;

  const currentVariant = variants.find(function(variant) {
    return String(variant.id) === String(currentVariantId);
  }) || variants[0];

  if (!currentVariant) return;

  const selectedOptions = [
    currentVariant.option1,
    currentVariant.option2,
    currentVariant.option3
  ];

  selectedOptions[optionPosition - 1] = optionValue;

  cardWrapper.querySelectorAll('.js-card-option-button.is-selected').forEach(function(selectedButton) {
    const selectedPosition = Number(selectedButton.dataset.optionPosition);
    const selectedValue = selectedButton.dataset.optionValue;

    if (selectedPosition && selectedValue && selectedPosition !== optionPosition) {
      selectedOptions[selectedPosition - 1] = selectedValue;
    }
  });

  let selectedVariant = variants.find(function(variant) {
    return (
      normalizeProductCardOption(variant.option1) === normalizeProductCardOption(selectedOptions[0]) &&
      normalizeProductCardOption(variant.option2) === normalizeProductCardOption(selectedOptions[1]) &&
      normalizeProductCardOption(variant.option3) === normalizeProductCardOption(selectedOptions[2])
    );
  });

  if (!selectedVariant) {
    selectedVariant = variants.find(function(variant) {
      return normalizeProductCardOption(variant['option' + optionPosition]) === normalizeProductCardOption(optionValue);
    });
  }

  if (!selectedVariant) return;

  variantOptionsWrapper.dataset.currentVariantId = selectedVariant.id;

  updateSelectedOptionButtons(cardWrapper, button, optionPosition);
  updateCardPrice(cardWrapper, selectedVariant);
  updateCardMpn(cardWrapper, selectedVariant);
  updateCardDelivery(cardWrapper, selectedVariant);
  updateCardImage(cardWrapper, selectedVariant);
  updateCardLinks(cardWrapper, selectedVariant);
  updateComplementaryCardForm(cardWrapper, selectedVariant);
});

function updateSelectedOptionButtons(cardWrapper, clickedButton, optionPosition) {
  cardWrapper
    .querySelectorAll('.js-card-option-button[data-option-position="' + optionPosition + '"]')
    .forEach(function(button) {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');

      if (button.classList.contains('product-card__option-button')) {
        button.classList.remove('btn-primary');
        button.classList.add('btn-secondary');
      }
    });

  clickedButton.classList.add('is-selected');
  clickedButton.setAttribute('aria-pressed', 'true');

  if (clickedButton.classList.contains('product-card__option-button')) {
    clickedButton.classList.add('btn-primary');
    clickedButton.classList.remove('btn-secondary');
  }
}

function updateCardPrice(cardWrapper, selectedVariant) {
  const priceWrapper = cardWrapper.querySelector('.js-card-price-wrapper');

  if (priceWrapper && selectedVariant.priceHtml) {
    priceWrapper.innerHTML = selectedVariant.priceHtml;
  }

  updateCardPriceSize(cardWrapper, selectedVariant.price);
}

function updateCardPriceSize(cardWrapper, priceCents) {
  const price = Number(priceCents);

  cardWrapper.classList.toggle(
    'product-card--compact-price',
    Number.isFinite(price) && price >= 1000000
  );
}

function initializeCardPriceSizes() {
  document.querySelectorAll('.product-card__wrapper').forEach(function(cardWrapper) {
    const optionsWrapper = cardWrapper.querySelector('.js-card-variant-options');
    const variantDataScript = optionsWrapper && optionsWrapper.querySelector('.js-card-variant-data');

    if (!variantDataScript) {
      const renderedPrice = cardWrapper.querySelector('.product-card__purchase-price .price-item');
      const priceDigits = renderedPrice && renderedPrice.textContent.replace(/[^0-9]/g, '');
      updateCardPriceSize(cardWrapper, priceDigits);
      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(variantDataScript.textContent);
    } catch (error) {
      return;
    }

    const currentVariantId = optionsWrapper.dataset.currentVariantId;
    const selectedVariant = variants.find(function(variant) {
      return String(variant.id) === String(currentVariantId);
    }) || variants[0];

    if (selectedVariant) {
      updateCardPriceSize(cardWrapper, selectedVariant.price);
    }
  });
}

function updateCardMpn(cardWrapper, selectedVariant) {
  const mpnWrapper = cardWrapper.querySelector('.js-card-variant-mpn');

  if (!mpnWrapper) return;

  if (selectedVariant.mpn) {
    mpnWrapper.textContent = selectedVariant.mpn;
    mpnWrapper.classList.remove('d-none');
  } else {
    mpnWrapper.textContent = '';
    mpnWrapper.classList.add('d-none');
  }
}

function updateCardDelivery(cardWrapper, selectedVariant) {
  const inventoryBlock = cardWrapper.querySelector('.js-inventory-tracking');

  if (!inventoryBlock) return;

  const availabilityEl = inventoryBlock.querySelector('.icon-dot-shadow');
  const deliveryEl = inventoryBlock.querySelector('.ev-delivery-estimate');

  if (!availabilityEl || !deliveryEl) return;

  availabilityEl.textContent = selectedVariant.availabilityLabel || '';
  deliveryEl.textContent = selectedVariant.deliveryText || '';

  inventoryBlock.dataset.variantId = selectedVariant.id;
  inventoryBlock.dataset.deliveryProfile = selectedVariant.deliveryProfile || '';

  availabilityEl.className =
    'product-inventory-tracking icon-dot-shadow ' +
    (selectedVariant.stockClass || '') +
    ' ' +
    (selectedVariant.statusClass || '') +
    ' p-relative';

  deliveryEl.className =
    'product-inventory-tracking d-block mt-2 ' +
    (selectedVariant.statusClass || '') +
    ' p-relative ev-delivery-estimate';
}

function updateCardImage(cardWrapper, selectedVariant) {
  if (!selectedVariant.image || !selectedVariant.image.src) return;

  const image = cardWrapper.querySelector('.card__media img[id^="cardProductImage-"]');

  if (!image) return;

  image.src = selectedVariant.image.src;

  if (selectedVariant.image.srcset) {
    image.srcset = selectedVariant.image.srcset;
  }

  if (selectedVariant.image.alt) {
    image.alt = selectedVariant.image.alt;
  }
}

function updateCardLinks(cardWrapper, selectedVariant) {
  const productLinks = cardWrapper.querySelectorAll('a[href*="/products/"]');

  productLinks.forEach(function(link) {
    const baseUrl = link.href.split('?')[0];
    link.href = baseUrl + '?variant=' + selectedVariant.id;
  });

  const quickBuyButtons = cardWrapper.querySelectorAll('[data-product-url*="view=quick-buy"]');

  quickBuyButtons.forEach(function(button) {
    const productUrl = button.dataset.productUrl;
    if (!productUrl) return;

    const baseUrl = productUrl.split('?')[0];

    button.dataset.productUrl = baseUrl + '?variant=' + selectedVariant.id + '&view=quick-buy';
  });

  const quickViewButtons = cardWrapper.querySelectorAll('[data-product-url*="view=quick-view"]');

  quickViewButtons.forEach(function(button) {
    const productUrl = button.dataset.productUrl;
    if (!productUrl) return;

    const baseUrl = productUrl.split('?')[0];

    button.dataset.productUrl = baseUrl + '?variant=' + selectedVariant.id + '&view=quick-view';
  });
}

function updateComplementaryCardForm(cardWrapper, selectedVariant) {
const variantInput = cardWrapper.querySelector('.js-card-selected-variant-id');
const addButton = cardWrapper.querySelector('.complementary-card__add');
const addButtonText = cardWrapper.querySelector('.complementary-card__add-text');

if (variantInput) {
  variantInput.value = selectedVariant.id;
}

if (addButton) {
  if (selectedVariant.available) {
    addButton.disabled = false;
    if (addButtonText) addButtonText.textContent = 'Προσθήκη';
  } else {
    addButton.disabled = true;
    if (addButtonText) addButtonText.textContent = 'Μη διαθέσιμο';
  }
}
}

function normalizeProductCardOption(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/\s+/g, '')
    .trim();
}

(function() {
  const DESKTOP_QUERY = '(min-width: 990px)';
  const CARD_SELECTOR = '.product-card__wrapper:not(.complementary-card__wrapper)';
  const MPN_SELECTOR = '.product-card__mpn';
  const OPTIONS_SELECTOR = '.product-card__options-under-title';
  const OPTION_BUTTON_GROUP_SELECTOR = '.product-card__variant-values--button';
  const OPTION_BUTTON_SELECTOR = '.product-card__option-button';

  let timer = null;
  let isRunning = false;

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function getVisibleCards() {
    return Array.from(document.querySelectorAll(CARD_SELECTOR)).filter(function(card) {
      return card.offsetParent !== null;
    });
  }

  function clearAlignment(cards) {
    cards.forEach(function(card) {
      card.classList.remove('product-card--row-aligned');
      card.classList.remove('product-card--row-measuring');
      card.style.removeProperty('--product-card-mpn-offset');
      card.style.removeProperty('--product-card-options-offset');
    });
  }

  function measureOptionButtonWidth(button) {
    const clone = button.cloneNode(true);

    clone.style.setProperty('position', 'absolute', 'important');
    clone.style.setProperty('visibility', 'hidden', 'important');
    clone.style.setProperty('pointer-events', 'none', 'important');
    clone.style.setProperty('width', 'auto', 'important');
    clone.style.setProperty('min-width', '0', 'important');
    clone.style.setProperty('max-width', 'none', 'important');
    clone.style.setProperty('white-space', 'nowrap', 'important');
    clone.style.setProperty('left', '-9999px', 'important');
    clone.style.setProperty('top', '-9999px', 'important');

    document.body.appendChild(clone);

    const width = Math.ceil(clone.getBoundingClientRect().width);

    clone.remove();

    return width;
  }

  function syncProductCardOptionButtonWidths() {
    document.querySelectorAll(OPTION_BUTTON_GROUP_SELECTOR).forEach(function(group) {
      const buttons = Array.from(group.querySelectorAll(OPTION_BUTTON_SELECTOR));

      if (!buttons.length) return;

      group.style.removeProperty('--product-card-option-button-width');

      const measuredWidth = Math.max.apply(null, buttons.map(measureOptionButtonWidth));
      const width = Math.max(56, Math.min(measuredWidth, 98));

      group.style.setProperty('--product-card-option-button-width', width + 'px');
    });
  }

  function groupCardsByVisualRow(cards) {
    const rows = [];

    cards.forEach(function(card) {
      const top = Math.round(card.getBoundingClientRect().top);

      let row = rows.find(function(existingRow) {
        return Math.abs(existingRow.top - top) <= 3;
      });

      if (!row) {
        row = {
          top: top,
          cards: []
        };

        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows;
  }

  function getMpnTopInsideCard(card) {
    const mpn = card.querySelector(MPN_SELECTOR);

    if (!mpn) {
      return 0;
    }

    const cardRect = card.getBoundingClientRect();
    const mpnRect = mpn.getBoundingClientRect();

    return Math.round(mpnRect.top - cardRect.top);
  }

  function hasVisibleOptions(card) {
    const options = card.querySelector(OPTIONS_SELECTOR);

    if (!options) return false;

    return !!options.querySelector('.product-card__color-button, .product-card__option-button');
  }

  function getOptionsTopInsideCard(card) {
    const options = card.querySelector(OPTIONS_SELECTOR);

    if (!options || !hasVisibleOptions(card)) {
      return null;
    }

    const cardRect = card.getBoundingClientRect();
    const optionsRect = options.getBoundingClientRect();

    return Math.round(optionsRect.top - cardRect.top);
  }

  function alignDesktopProductCardRows() {
    if (isRunning) return;

    isRunning = true;

    const cards = getVisibleCards();

    if (!cards.length) {
      isRunning = false;
      return;
    }

    clearAlignment(cards);

    if (!isDesktop()) {
      isRunning = false;
      return;
    }

    /*
      Measure cards with MPN margin-top set to 0.
      This reveals the natural position after:
      Image
      Title
      Optional color swatch
      Optional variant swatch
    */
    cards.forEach(function(card) {
      card.classList.add('product-card--row-measuring');
    });

    requestAnimationFrame(function() {
      const rows = groupCardsByVisualRow(cards);

      rows.forEach(function(row) {
      /*
        Step 1:
        Align visible option rows per desktop row.
        This moves the option row down on cards with shorter titles,
        without touching cards that have no options.
      */
      const optionMeasurements = row.cards
        .filter(function(card) {
          return hasVisibleOptions(card);
        })
        .map(function(card) {
          return {
            card: card,
            optionsTop: getOptionsTopInsideCard(card)
          };
        })
        .filter(function(item) {
          return item.optionsTop !== null;
        });

      if (optionMeasurements.length > 1) {
        const targetOptionsTop = Math.max.apply(null, optionMeasurements.map(function(item) {
          return item.optionsTop;
        }));

        optionMeasurements.forEach(function(item) {
          const offset = Math.max(0, targetOptionsTop - item.optionsTop);
          item.card.style.setProperty('--product-card-options-offset', offset + 'px');
        });
      }

      /*
        Step 2:
        Apply the option alignment before measuring MPN position.
      */
      row.cards.forEach(function(card) {
        card.classList.remove('product-card--row-measuring');
        card.classList.add('product-card--row-aligned');
      });
    });

    requestAnimationFrame(function() {
      const updatedRows = groupCardsByVisualRow(cards);

      updatedRows.forEach(function(row) {
        /*
          Step 3:
          Re-align MPN/divider after option rows have been adjusted.
          This preserves the divider placement you already like.
        */
        const rowMeasurements = row.cards.map(function(card) {
          return {
            card: card,
            mpnTop: getMpnTopInsideCard(card)
          };
        });

        const targetMpnTop = Math.max.apply(null, rowMeasurements.map(function(item) {
          return item.mpnTop;
        }));

        rowMeasurements.forEach(function(item) {
          const offset = Math.max(0, targetMpnTop - item.mpnTop);
          item.card.style.setProperty('--product-card-mpn-offset', offset + 'px');
        });
      });

      isRunning = false;
    });

    });
  }

  function scheduleProductCardRowAlignment() {
    window.clearTimeout(timer);

    timer = window.setTimeout(function() {
      syncProductCardOptionButtonWidths();
      requestAnimationFrame(alignDesktopProductCardRows);
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', scheduleProductCardRowAlignment);
  window.addEventListener('load', scheduleProductCardRowAlignment);
  window.addEventListener('resize', scheduleProductCardRowAlignment);
  window.addEventListener('orientationchange', scheduleProductCardRowAlignment);

document.addEventListener('click', function(event) {
    if (
      event.target.closest('[data-sort-by]') ||
      event.target.closest('[data-filter]') ||
      event.target.closest('facet-remove') ||
      event.target.closest('sht-filter') ||
      event.target.closest('sht-sort-by') ||
      event.target.closest('sht-product-filter')
    ) {
      scheduleProductCardRowAlignment();
    }
});

document.addEventListener('DOMContentLoaded', initializeCardPriceSizes);

  document.addEventListener('change', function(event) {
    if (
      event.target.closest('select') ||
      event.target.closest('input[type="checkbox"]') ||
      event.target.closest('input[type="radio"]')
    ) {
      scheduleProductCardRowAlignment();
    }
  });

  document.addEventListener('shopify:section:load', scheduleProductCardRowAlignment);

  const observer = new MutationObserver(function(mutations) {
    const shouldRealign = mutations.some(function(mutation) {
      /*
        Ignore internal product-card updates caused by swatches:
        price, MPN, delivery text, image src/srcset, selected button classes, etc.
      */
      if (
        mutation.target &&
        mutation.target.closest &&
        mutation.target.closest('.product-card__wrapper')
      ) {
        return false;
      }

      return mutation.type === 'childList';
    });

    if (shouldRealign) {
      scheduleProductCardRowAlignment();
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    const grid =
      document.querySelector('#ProductGridContainer') ||
      document.querySelector('.product-grid') ||
      document.querySelector('[data-product-grid]') ||
      document.querySelector('main');

    if (grid) {
      observer.observe(grid, {
        childList: true,
        subtree: true
      });
    }
  });

  document.querySelectorAll('.product-card__wrapper img').forEach(function(image) {
    if (!image.complete) {
      image.addEventListener('load', scheduleProductCardRowAlignment, { once: true });
    }
  });
})();

/* Keep cart shipping info popups reliable in the drawer and full cart. */
(function cartShippingInfoHover() {
  function desktopHover() {
    return window.matchMedia('(min-width: 769px)').matches &&
      !('ontouchstart' in window) &&
      !(navigator.maxTouchPoints > 0);
  }

  function position(info) {
    const trigger = info.querySelector('.cart-shipping-info__trigger');
    const popup = info.querySelector('.cart-shipping-info__popup');
    if (!trigger || !popup) return;
    const rect = trigger.getBoundingClientRect();
    const width = Math.min(320, window.innerWidth - 32);
    popup.style.display = 'block';
    popup.style.width = width + 'px';
    popup.style.left = Math.max(16, Math.min(rect.right - width, window.innerWidth - width - 16)) + 'px';
    popup.style.top = Math.max(16, rect.top - popup.offsetHeight - 8) + 'px';
  }

  function setOpen(info, open) {
    info.classList.toggle('is-open', open);
    const trigger = info.querySelector('.cart-shipping-info__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function bind() {
    document.querySelectorAll('.cart-shipping-info').forEach(function (info) {
      if (info.dataset.cartInfoBound === 'true') return;
      const trigger = info.querySelector('.cart-shipping-info__trigger');
      if (!trigger) return;
      info.dataset.cartInfoBound = 'true';
      function show() {
        if (!desktopHover()) return;
        setOpen(info, true);
        info.classList.add('is-hovering');
        requestAnimationFrame(function () { position(info); });
      }
      function hide() {
        if (!desktopHover()) return;
        setOpen(info, false);
        info.classList.remove('is-hovering');
        const popup = info.querySelector('.cart-shipping-info__popup');
        if (popup) popup.style.display = '';
      }
      info.addEventListener('mouseenter', show);
      info.addEventListener('mouseleave', hide);
      info.addEventListener('pointerenter', show);
      info.addEventListener('pointerleave', hide);
      trigger.addEventListener('click', function (event) {
        if (desktopHover()) return;
        event.preventDefault();
        const nextOpen = !info.classList.contains('is-open');
        setOpen(info, nextOpen);
        const popup = info.querySelector('.cart-shipping-info__popup');
        if (nextOpen) position(info);
        else if (popup) popup.style.display = '';
      });
    });
  }

  bind();
  new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (event) {
    if (desktopHover()) return;
    document.querySelectorAll('.cart-shipping-info.is-open').forEach(function (info) {
      if (info.contains(event.target)) return;
      setOpen(info, false);
      const popup = info.querySelector('.cart-shipping-info__popup');
      if (popup) popup.style.display = '';
    });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.cart-shipping-info.is-hovering').forEach(position);
  });
})();

/* Show product shipping information on desktop hover without requiring an initial click. */
(function shippingInfoHover() {
  function isDesktopHover() {
    return window.matchMedia('(min-width: 769px)').matches &&
      !('ontouchstart' in window) &&
      !(navigator.maxTouchPoints > 0);
  }

  function positionMobilePopup(info) {
    if (!info.open || isDesktopHover()) return;
    const trigger = info.querySelector('.product-shipping-info__trigger');
    const popup = info.querySelector('.product-shipping-info__popup');
    if (!trigger || !popup) return;

    popup.style.display = 'block';
    popup.style.right = 'auto';
    // Keep the mobile popover a little narrower so longer explanations wrap
    // into a comfortable, taller box instead of stretching across the screen.
    popup.style.width = Math.min(290, window.innerWidth - 40) + 'px';

    const triggerRect = trigger.getBoundingClientRect();
    const popupRect = popup.getBoundingClientRect();
    const margin = 16;
    const gap = 12;
    const left = Math.max(margin, Math.min(
      triggerRect.left + (triggerRect.width / 2) - (popupRect.width / 2),
      window.innerWidth - popupRect.width - margin
    ));
    const aboveTop = triggerRect.top - popupRect.height - gap;
    const belowTop = triggerRect.bottom + gap;
    const top = aboveTop >= margin
      ? aboveTop
      : Math.min(belowTop, window.innerHeight - popupRect.height - margin);

    popup.style.left = left + 'px';
    popup.style.top = Math.max(margin, top) + 'px';
  }

  function clearMobilePopupPosition(info) {
    const popup = info.querySelector('.product-shipping-info__popup');
    if (!popup) return;
    popup.style.removeProperty('display');
    popup.style.removeProperty('left');
    popup.style.removeProperty('right');
    popup.style.removeProperty('top');
    popup.style.removeProperty('width');
  }

  function bind() {
    document.querySelectorAll('body.template-product .product-shipping-info').forEach(function (info) {
      if (info.dataset.clickBound === 'true') return;
      const trigger = info.querySelector('.product-shipping-info__trigger');
      if (!trigger) return;
      info.dataset.clickBound = 'true';
      trigger.addEventListener('click', function (event) {
        if (isDesktopHover()) return;
        event.preventDefault();
        const nextOpen = !info.open;
        // iOS can still run the native <summary> toggle after the click
        // handler. Re-apply the intended state on the next frame so a tap
        // reliably opens/closes the popover on the first interaction.
        info.open = nextOpen;
        requestAnimationFrame(function () {
          info.open = nextOpen;
        });
        if (nextOpen) {
          requestAnimationFrame(function () { positionMobilePopup(info); });
        } else {
          clearMobilePopupPosition(info);
        }
      });

      info.addEventListener('toggle', function () {
        if (info.open && !isDesktopHover()) {
          requestAnimationFrame(function () { positionMobilePopup(info); });
        } else if (!info.open) {
          clearMobilePopupPosition(info);
        }
      });
    });

    // On touch devices, tapping anywhere outside the open popover (or its
    // trigger) dismisses it. Keep this listener global and bind it once so
    // section updates do not add duplicate handlers.
    if (!document.documentElement.dataset.shippingOutsideBound) {
      document.documentElement.dataset.shippingOutsideBound = 'true';
      document.addEventListener('click', function (event) {
        if (isDesktopHover()) return;
        document.querySelectorAll('body.template-product .product-shipping-info[open]').forEach(function (info) {
          if (info.contains(event.target)) return;
          info.open = false;
          clearMobilePopupPosition(info);
        });
      });
    }

    if (!isDesktopHover()) return;
    document.querySelectorAll('body.template-product .product-shipping-info').forEach(function (info) {
      if (info.dataset.hoverBound === 'true') return;
      info.dataset.hoverBound = 'true';
      function showOnHover() {
        if (!isDesktopHover()) return;
        info.open = true;
        info.classList.add('is-hovering');
      }
      function hideOnLeave() {
        if (!isDesktopHover()) return;
        info.open = false;
        info.classList.remove('is-hovering');
      }
      info.addEventListener('mouseenter', showOnHover);
      info.addEventListener('mouseleave', hideOnLeave);
      info.addEventListener('pointerenter', showOnHover);
      info.addEventListener('pointerleave', hideOnLeave);
    });
  }

  bind();
  new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', function () {
    if (!isDesktopHover()) {
      document.querySelectorAll('.product-shipping-info.is-hovering').forEach(function (info) {
        info.classList.remove('is-hovering');
      });
      document.querySelectorAll('.product-shipping-info[open]').forEach(positionMobilePopup);
    } else {
      document.querySelectorAll('.product-shipping-info').forEach(clearMobilePopupPosition);
    }
    bind();
  });
})();

/* Keep complementary product cards the same height as the tallest card. */
(function equalizeComplementaryCardHeights() {
  const containerSelector = 'body.template-product .complementary-products';
  const cardSelector = '.complementary-card';
  const scheduled = new WeakMap();

  function equalize(container) {
    const cards = Array.from(container.querySelectorAll(cardSelector));
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.style.height = 'auto';
    });

    requestAnimationFrame(function () {
      const tallest = Math.max.apply(null, cards.map(function (card) {
        return Math.ceil(card.getBoundingClientRect().height);
      }));
      if (!tallest) return;
      cards.forEach(function (card) {
        card.style.height = tallest + 'px';
      });
    });
  }

  function schedule(container) {
    if (scheduled.get(container)) return;
    scheduled.set(container, true);
    requestAnimationFrame(function () {
      scheduled.delete(container);
      equalize(container);
    });
  }

  function observe(container) {
    if (container.dataset.complementaryHeightSync === 'true') return;
    container.dataset.complementaryHeightSync = 'true';

    new MutationObserver(function () {
      schedule(container);
    }).observe(container, { childList: true, subtree: true });

    container.querySelectorAll('img').forEach(function (image) {
      image.addEventListener('load', function () {
        schedule(container);
      });
    });
    schedule(container);
  }

  function observeAll() {
    document.querySelectorAll(containerSelector).forEach(observe);
  }

  observeAll();
  new MutationObserver(observeAll).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', function () {
    observeAll();
    document.querySelectorAll(containerSelector).forEach(schedule);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      document.querySelectorAll(containerSelector).forEach(schedule);
    });
  }
})();
